import ServiceAccountId from "../../state/ServiceAccountId";
import type { ServiceAccountDto } from "../../services/ServiceAccountService";
import type { ServiceAccount } from "../../types/ServiceAccount";

export const toServiceAccount = (dto: ServiceAccountDto): ServiceAccount => ({
  id: ServiceAccountId.from(dto.id),
  type: dto.authType,
  name: dto.displayName ?? undefined,
  identifier: dto.accountIdentifier ?? undefined,
  meta: {
    createdOn: dto.meta.createdOn,
  },
});
